import React, { useMemo } from 'react';
import clsx from 'clsx';
import { TripTaskDirectionDataService } from 'components/map/map-container/direction-data/trip-task-direction-data-service';
import { ESetCargosMarkersMode } from 'components/map/map-container/hooks/types';
import { useDirection } from 'components/map/map-container/hooks/use-direction.ts';
import { useInitMap } from 'components/map/map-container/hooks/use-init-map.ts';
import { useSetCargosMarkers } from 'components/map/map-container/hooks/use-set-cargos-markers.ts';
import { useSetTransportsMarkers } from 'components/map/map-container/hooks/use-set-transports-markers.ts';
import { useSetWarehousesMarkers } from 'components/map/map-container/hooks/use-set-warehouses-markers.ts';
import styles from './trip-map-container.module.scss';
import type { ITripMapContainerProps } from './types';

export const TripMapContainer: React.FC<ITripMapContainerProps> = (props) => {
  const { tripTasks, cargoTrips, warehouses, transports, isBig = false } = props;
  const { map, mapBoxRef } = useInitMap();

  const cargos = useMemo(() => cargoTrips?.map((cargoTrip) => cargoTrip.cargo) || [], [cargoTrips]);

  const directionDataService = useMemo(() => {
    return new TripTaskDirectionDataService({ tripTasks: tripTasks || [] });
  }, [tripTasks]);

  useSetWarehousesMarkers({ map, warehouses });
  useSetCargosMarkers({
    map,
    cargos,
    setMode: ESetCargosMarkersMode.FULL,
  });
  useDirection({ map, directionDataService });
  useSetTransportsMarkers({ map, transports });

  const boxClasses = clsx(styles.mapBox, {
    [styles.big]: isBig,
  });

  return <div ref={mapBoxRef} className={boxClasses} />;
};
